/**
 * @fileoverview WhatsNewGiftIcon — inline gradient gift-shaped SVG atom for
 * the "Platform updates" help-menu row. Uses `useId()` to suffix the
 * linear-gradient ID so multiple instances on the same page coexist without
 * DOM-id collisions. Decorative — labeling comes from the parent MenuItem.
 *
 * Foundry mapping: `release-notes__gift-icon__1nwd5eg` — the inline gift glyph
 * with a soft purple-to-cyan gradient that signals "what's new".
 */

import { useId } from "react";
import type { ReactElement } from "react";

interface WhatsNewGiftIconProps {
  size?: number;
  className?: string;
}

export function WhatsNewGiftIcon({ size = 16, className }: WhatsNewGiftIconProps): ReactElement {
  const id = useId();
  const gradId = `gift-grad-${id}`;

  return (
    <svg data-testid="whatsnew-gift-icon"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      <defs>
        <linearGradient id={gradId} x1="2" y1="2" x2="14" y2="14" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#9B7BFF" />
          <stop offset="100%" stopColor="#36C5F0" />
        </linearGradient>
      </defs>
      {/* Box body */}
      <path
        d="M2 6h12v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6z"
        fill={`url(#${gradId})`}
      />
      {/* Ribbon vertical */}
      <path d="M7 4h2v11H7z" fill={`url(#${gradId})`} opacity="0.85" />
      {/* Bow */}
      <path
        d="M5 2.5C5 3.33 5.67 4 6.5 4H8V2.5a1.5 1.5 0 0 0-3 0zM11 2.5C11 3.33 10.33 4 9.5 4H8V2.5a1.5 1.5 0 0 1 3 0z"
        fill={`url(#${gradId})`}
      />
    </svg>
  );
}
